import { Validators } from '@angular/forms';

export const validateHexColorString = Validators.compose([
  Validators.pattern(/#([a-fA-F0-9]{6})$/),
  Validators.minLength(1),
  Validators.maxLength(7),
]);
